<div id="layout" class="theme-cyan">
  <app-event-leftmenu></app-event-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Analytics Daashboard</h5>
                  </div>
                  <small class="text-truncate text-muted">Total 15 (last update 1hr ago)</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a class="nav-link text-muted" [routerLink]="['/event-add']" href="javascript:void(0)">Add</a>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0)">List view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Grid view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Add new</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>
            </div>

          </div> <!-- / .row -->

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-5">
        <div class="container">

          <div class="row g-2">
            <div class="col-xl-6 col-lg-12">
              <div class="card mb-2">
                <div class="card-body">
                  <h6 class="card-title">Sales Analytics</h6>
                </div>
                <app-area-chart></app-area-chart>
              </div>
              <div class="card mb-2 bg-transparent">
                <div class="card-body">
                  <h6 class="card-title mb-4">Recent sales</h6>
                  <div class="d-flex">
                    <div class="pe-5 border-end">
                      <small>This Week</small>
                      <h5 class="fw-bold">225</h5>
                    </div>
                    <div class="ps-5">
                      <small>Previous Month</small>
                      <h5 class="fw-bold">1,254</h5>
                    </div>
                  </div>
                </div>
                <ul class="list-group list-group-flush custom">
                  <li class="list-group-item">
                    <div class="row align-items-center">
                      <!-- Avatar -->
                      <div class="col-auto">
                        <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar1.jpg" alt="..."
                            class="rounded-circle"></a>
                      </div>

                      <div class="col ml-n2">
                        <!-- Title -->
                        <h6 class="mb-1"><a href="javascript:void(0)">Michelle Green</a></h6>
                        <!-- Text -->
                        <p class="text-muted mb-0">React FrontEnd developer</p>
                      </div>

                      <!-- Button -->
                      <div class="col-auto">
                        <span class="badge bg-danger">DM</span>
                        <span class="badge bg-dark ml-1">25</span>
                      </div>

                      <!-- Dropdown -->
                      <div class="col-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                            dropdownToggle type="button" aria-controls="dropdown-alignment">
                            <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                          </a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a href="javascript:void(0)" class="dropdown-item">Action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div> <!-- / .row -->
                  </li>
                  <li class="list-group-item">
                    <div class="row align-items-center">
                      <!-- Avatar -->
                      <div class="col-auto">
                        <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar2.jpg" alt="..."
                            class="rounded-circle"></a>
                      </div>

                      <div class="col ml-n2">
                        <!-- Title -->
                        <h6 class="mb-1"><a href="javascript:void(0)">Darryl Day</a></h6>
                        <!-- Text -->
                        <p class="text-muted mb-0">React FrontEnd developer</p>
                      </div>

                      <!-- Button -->
                      <div class="col-auto">
                        <span class="badge bg-danger">DM</span>
                        <span class="badge bg-dark ml-1">25</span>
                      </div>

                      <!-- Dropdown -->
                      <div class="col-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                            dropdownToggle type="button" aria-controls="dropdown-alignment">
                            <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                          </a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a href="javascript:void(0)" class="dropdown-item">Action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div> <!-- / .row -->
                  </li>
                  <li class="list-group-item">
                    <div class="row align-items-center">
                      <!-- Avatar -->
                      <div class="col-auto">
                        <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar3.jpg" alt="..."
                            class="rounded-circle"></a>
                      </div>

                      <div class="col ml-n2">
                        <!-- Title -->
                        <h6 class="mb-1"><a href="javascript:void(0)">Jason Porter</a></h6>
                        <!-- Text -->
                        <p class="text-muted mb-0">National Mentoring Month 2021</p>
                      </div>

                      <!-- Button -->
                      <div class="col-auto">
                        <span class="badge bg-danger">XL</span>
                        <span class="badge bg-dark ml-1">25</span>
                      </div>

                      <!-- Dropdown -->
                      <div class="col-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                            dropdownToggle type="button" aria-controls="dropdown-alignment">
                            <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                          </a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a href="javascript:void(0)" class="dropdown-item">Action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div> <!-- / .row -->
                  </li>
                  <li class="list-group-item">
                    <div class="row align-items-center">
                      <!-- Avatar -->
                      <div class="col-auto">
                        <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar4.jpg" alt="..."
                            class="rounded-circle"></a>
                      </div>

                      <div class="col ml-n2">
                        <!-- Title -->
                        <h6 class="mb-1"><a href="javascript:void(0)">Daniel Kristeen</a></h6>
                        <!-- Text -->
                        <p class="text-muted mb-0">World Braille Day 2021</p>
                      </div>

                      <!-- Button -->
                      <div class="col-auto">
                        <span class="badge bg-danger">DM</span>
                        <span class="badge bg-dark ml-1">25</span>
                      </div>

                      <!-- Dropdown -->
                      <div class="col-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                            dropdownToggle type="button" aria-controls="dropdown-alignment">
                            <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                          </a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a href="javascript:void(0)" class="dropdown-item">Action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div> <!-- / .row -->
                  </li>
                  <li class="list-group-item">
                    <div class="row align-items-center">
                      <!-- Avatar -->
                      <div class="col-auto">
                        <a href="javascript:void(0)" class="avatar"><img src="../assets/images/xs/avatar5.jpg" alt="..."
                            class="rounded-circle"></a>
                      </div>

                      <div class="col ml-n2">
                        <!-- Title -->
                        <h6 class="mb-1"><a href="javascript:void(0)">Amelia Green</a></h6>
                        <!-- Text -->
                        <p class="text-muted mb-0">Byron Bay Bluesfest</p>
                      </div>

                      <!-- Button -->
                      <div class="col-auto">
                        <span class="badge bg-danger">SM</span>
                        <span class="badge bg-dark ml-1">25</span>
                      </div>

                      <!-- Dropdown -->
                      <div class="col-auto">
                        <div class="dropdown" dropdown placement="bottom right">
                          <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                            dropdownToggle type="button" aria-controls="dropdown-alignment">
                            <i class="zmdi zmdi-more zmdi-hc-lg"></i>
                          </a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a href="javascript:void(0)" class="dropdown-item">Action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div> <!-- / .row -->
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-6 col-lg-12">
              <div class="row row-deck g-2">
                <div class="col-xl-6 col-lg-6">
                  <div class="card p-3 px-4">
                    <div>Total revenue</div>
                    <div class="py-4 m-0 text-center h2 text-primary">$9,452</div>
                    <div class="d-flex">
                      <small class="text-muted">Income</small>
                      <div class="ms-auto"><i class="zmdi zmdi-trending-up text-success me-2"></i>4%</div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                  <div class="card p-3 px-4">
                    <div>Ticket Ordered</div>
                    <div class="py-4 m-0 text-center h2 text-warning">69 Pcs</div>
                    <div class="d-flex">
                      <small class="text-muted">Sold Today</small>
                      <div class="ms-auto">23%</div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-3">
                  <div class="card">
                    <div class="card-body text-center">
                      <h6 class="card-title">Tickets</h6>
                      <app-basicradar-chart></app-basicradar-chart>
                      <div class="border-bottom py-3">
                        <span class="text-muted">Total Tickets</span>
                        <h6 class="mb-0">$3400.00</h6>
                      </div>
                      <div class="pt-3">
                        <span class="text-muted">Sold Tickets</span>
                        <h6 class="mb-0">$7300.00</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-3">
                  <div class="card">
                    <div class="card-body text-center">
                      <h6 class="card-title">Seats</h6>
                      <app-basicradar-chart></app-basicradar-chart>
                      <div class="border-bottom py-3">
                        <span class="text-muted">Total Seats</span>
                        <h6 class="mb-0">$3700.00</h6>
                      </div>
                      <div class="pt-3">
                        <span class="text-muted">Sold Seats</span>
                        <h6 class="mb-0">$9200.00</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-12 col-lg-6">
                  <div class="card mb-4">
                    <div class="card-body">
                      <h6 class="card-title mb-4">Users Overview</h6>
                      <div class="d-flex justify-content-center">
                        <div class="col-6 border-end">
                          <small>New Users</small>
                          <h4 class="fw-bold">2,025</h4>
                        </div>
                        <div class="col-6">
                          <small>Return Visitors</small>
                          <h4 class="fw-bold">1,254</h4>
                        </div>
                      </div>
                      <hr>
                      <div class="form-group mb-4">
                        <label class="d-block">New Users <span class="float-end">77%</span></label>
                        <div class="progress" style="height: 2px;">
                          <div class="progress-bar bg-success" role="progressbar" aria-valuenow="77" aria-valuemin="0"
                            aria-valuemax="100" style="width: 77%;"></div>
                        </div>
                      </div>
                      <div class="form-group mb-4">
                        <label class="d-block">Return Visitors <span class="float-end">50%</span></label>
                        <div class="progress" style="height: 2px;">
                          <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="50" aria-valuemin="0"
                            aria-valuemax="100" style="width: 50%;"></div>
                        </div>
                      </div>
                      <div class="form-group mb-4">
                        <label class="d-block">Engagement <span class="float-end">23%</span></label>
                        <div class="progress" style="height: 2px;">
                          <div class="progress-bar progbgress-info" role="progressbar" aria-valuenow="23"
                            aria-valuemin="0" aria-valuemax="100" style="width: 23%;"></div>
                        </div>
                      </div>
                      <small>The total number of Page Impressions within the date range<a href="javascript:void(0)">View
                          more</a></small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> <!-- / .row -->

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
